var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75002 26.2481C6.53752 26.2519 6.32502 26.2156 6.12502 26.1406L16.1925 16.0694L19.525 19.4056L7.95627 25.9056C7.58986 26.1205 7.17469 26.2384 6.75002 26.2481ZM5.29502 25.4169C5.09037 25.0462 4.98852 24.6276 5.00002 24.2044V5.82312C4.99833 5.5441 5.04051 5.26655 5.12502 5.00062L15.4163 15.2944L5.29127 25.4194L5.29502 25.4169ZM20.5188 18.8444L16.9675 15.2956L20.8838 11.3806L24.3625 13.3344C25.03 13.6344 25.4775 14.2781 25.5225 15.0081C25.5004 15.3667 25.3804 15.7124 25.1757 16.0077C24.971 16.303 24.6893 16.5366 24.3613 16.6831L20.5188 18.8444ZM16.1925 14.5156L5.76752 4.09188C6.05377 3.87938 6.40002 3.76688 6.75627 3.76562C7.17627 3.78063 7.58627 3.89937 7.95002 4.11187L19.8888 10.8219L16.1938 14.5156H16.1925Z",
    fill: "#5034C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.829d931673422db054e071733938819a.svg";
export { ForwardRef as ReactComponent };